import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from "src/store";
import { API_PROD_URL } from "src/utils/axios";
import { generateKnowIdstring } from "src/utils/helpers";

export const ragUploadPdfs = createAsyncThunk(
    "post-rag-upload-pdfs",
    async (
        {
            formdata,
            userId,
            threadId,
            isExcel
        }: {
            formdata: FormData;
            userId: string;
            threadId: string;
            isExcel?: boolean
        },
        { getState },
    ): Promise<any> => {
        const state = getState() as RootState;
        // Temp Logic for fetching file from url

        const response: any = await axios.post(
            `${API_PROD_URL}/${isExcel ? "upload_levels_file" : "upload_pdfs"}?user_id=${userId}&thread_id=${threadId}`,
            formdata,
            {
                headers: { "Content-Type": "application/json", "ngrok-skip-browser-warning": "true" },
            },
        );
        return response;
    },
);

export const ragPostQuery = createAsyncThunk(
    "post-rag-query",
    async (
        {
            question,
            userId,
            threadId,
        }: {
            question: string;
            userId: string;
            threadId: string;
        },
        { getState },
    ): Promise<any> => {
        const state = getState() as RootState;
        // Temp Logic for fetching file from url



        const response: any = await axios.post(
            `${API_PROD_URL}/query?user_id=${userId}&thread_id=${threadId}`,
            {
                "question": question,
            },
            {
                headers: { "Content-Type": "application/json", "ngrok-skip-browser-warning": "true" },
            },
        );
        return response;
    },
);

export const ragGenerateThreadId = createAsyncThunk(
    "get-rag-thread-id",
    async (
        {
            userId,
        }: {
            userId: string;
        },
        { getState },
    ): Promise<any> => {
        const state = getState() as RootState;
        // Temp Logic for fetching file from url



        const response: any = await axios.get(
            `${API_PROD_URL}/pdf_qna/threads/get?user_id=${userId}&thread_name=${generateKnowIdstring()}`,
            {
                headers: { "Content-Type": "application/json", "ngrok-skip-browser-warning": "true" },
            },
        );
        return response;
    },
);

export const getUploadStatus = createAsyncThunk(
    "get-rag-upload-status",
    async (
        {
            job_id,
        }: {
            job_id: string;
        },
        { getState },
    ): Promise<any> => {
        const response: any = await axios.get(
            `${API_PROD_URL}/upload_status?job_id=${job_id}`,
            {
                headers: { "Content-Type": "application/json", "ngrok-skip-browser-warning": "true" },
            },
        );
        return response;
    },
);
